"use client";

import { c as _c } from "react/compiler-runtime";
import { ChainBadge, CollectionLockup, CollectionLockupAvatar, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { EM_DASH } from "@opensea/i18n";
import { Item, ItemContent, ItemTitle, Link } from "@opensea/next-ui-kit";
import { classNames, ItemDescription, LiveAnimation, TABLE_SIZES, TableCell, TableRow, TextOverflowTooltip, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { CollectionPreviewTooltip } from "../collection/CollectionPreviewTooltip/CollectionPreviewTooltip";
import { getCollectionUrlBySlug } from "../collection/utils";
import { ItemAvatar } from "../items/avatar/ItemAvatar";
import { ItemLink } from "../items/ItemLink";
import { ItemPreviewTooltip } from "../items/ItemPreviewTooltip/ItemPreviewTooltip";
import { ActivityEvent } from "./ActivityEvent";
import { ActivityEventDescription } from "./ActivityEventDescription";
import { ActivityFeedLiveTimestamp } from "./ActivityFeedLiveTimestamp";
import { ActivityFeedMarketplaceIcon } from "./ActivityFeedMarketplaceIcon";
import { ActivityFeedTableRowFragment } from "./ActivityFeedTableRow.fragment";
import { ActivityFeedTableSkeletonRow } from "./ActivityFeedTableSkeletonRow";
import { ActivityFeedTypeIcon } from "./ActivityFeedTypeIcon";
import { ActivityFrom } from "./ActivityFrom";
import { ActivityPrice } from "./ActivityPrice";
import { ActivityQuantity } from "./ActivityQuantity";
import { ActivityRarity } from "./ActivityRarity";
import { ActivityTo } from "./ActivityTo";
import { useActivityFeedColumns } from "./hooks";
import { ACTIVITY_TABLE_COLUMN_CLASSNAMES } from "./styles";
export function ActivityFeedTableRow(t0) {
  const $ = _c(59);
  const {
    item: itemKey,
    context
  } = t0;
  const columns = useActivityFeedColumns();
  const {
    size
  } = useTable();
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ActivityFeedTableRowFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activity = t1;
  if (!activity) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ActivityFeedTableSkeletonRow />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let T0;
  let T1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== activity || $[4] !== columns.event || $[5] !== columns.from || $[6] !== columns.hideCollection || $[7] !== columns.item || $[8] !== columns.price || $[9] !== columns.quantity || $[10] !== columns.rarity || $[11] !== columns.to || $[12] !== context?.itemsLiveAddedAt || $[13] !== context?.variant || $[14] !== size) {
    const {
      text,
      image
    } = tableRowSizeVariants({
      size
    });
    const {
      image: imageSize,
      badge: badgeSize
    } = TABLE_SIZES[size];
    const showChainBadge = Boolean(badgeSize);
    const {
      item,
      collection
    } = activity;
    let t12;
    if ($[27] !== activity) {
      t12 = <ActivityFeedTypeIcon activity={activity} />;
      $[27] = activity;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    const defaultIcon = t12;
    T1 = LiveAnimation;
    t9 = activity.id;
    if ($[29] !== activity.id || $[30] !== context?.itemsLiveAddedAt) {
      t10 = context?.itemsLiveAddedAt.get(activity.id);
      $[29] = activity.id;
      $[30] = context?.itemsLiveAddedAt;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    t11 = "table";
    T0 = TableRow;
    t2 = columns.event ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.event({
      variant: context?.variant
    })}><Item variant="unstyled"><ActivityFeedMarketplaceIcon activity={activity} fallback={defaultIcon} /><ItemContent><ItemTitle className={text()}><ActivityEvent activity={activity} /></ItemTitle><ItemDescription className={text()}><ActivityEventDescription activity={activity} /></ItemDescription></ItemContent></Item></TableCell> : null;
    t3 = columns.item ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.item}>{item !== null ? <Item variant="unstyled"><ItemPreviewTooltip item={item}><ItemLink item={item}><ItemAvatar badge={showChainBadge ? <ChainBadge chain={item.chain} size={badgeSize} /> : undefined} className={image()} item={item} size={imageSize} /></ItemLink></ItemPreviewTooltip><ItemContent><TextOverflowTooltip disabled={true}><ItemLink item={item}><ItemPreviewTooltip item={item}><ItemTitle className={text()}>{item.name}</ItemTitle></ItemPreviewTooltip></ItemLink></TextOverflowTooltip>{!columns.hideCollection && collection ? <CollectionPreviewTooltip collection={collection}>{context?.variant !== "collection" ? <Link className="max-w-full" href={getCollectionUrlBySlug(collection.slug)} onClick={_temp} prefetch="onHover" variant="unstyled"><CollectionLockup collection={collection}><CollectionLockupContent><CollectionLockupTitle color="text-secondary" containerClassName="w-full" disableTextOverflowTooltip={true} /></CollectionLockupContent></CollectionLockup></Link> : <CollectionLockup collection={collection}><CollectionLockupContent><CollectionLockupTitle color="text-secondary" containerClassName="w-full" disableTextOverflowTooltip={true} /></CollectionLockupContent></CollectionLockup>}</CollectionPreviewTooltip> : null}</ItemContent></Item> : collection ? <CollectionPreviewTooltip collection={collection}><CollectionLockup collection={collection} size={size}><Link href={getCollectionUrlBySlug(collection.slug)} prefetch="onHover" variant="unstyled"><CollectionLockupAvatar /></Link><ItemContent>{context?.variant !== "collection" ? <Link href={getCollectionUrlBySlug(collection.slug)} onClick={_temp2} prefetch="onHover" variant="unstyled"><CollectionLockupContent><CollectionLockupTitle className="font-normal" color="text-secondary" disableTextOverflowTooltip={true} /></CollectionLockupContent></Link> : <CollectionLockupContent><CollectionLockupTitle className="font-normal" color="text-secondary" disableTextOverflowTooltip={true} /></CollectionLockupContent>}</ItemContent></CollectionLockup></CollectionPreviewTooltip> : null}</TableCell> : null;
    if ($[32] !== activity || $[33] !== columns.price || $[34] !== context?.variant) {
      t4 = columns.price ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.price}><ActivityPrice activity={activity} context={{
          variant: context?.variant
        }} /></TableCell> : null;
      $[32] = activity;
      $[33] = columns.price;
      $[34] = context?.variant;
      $[35] = t4;
    } else {
      t4 = $[35];
    }
    t5 = columns.quantity ? <TableCell className={classNames(ACTIVITY_TABLE_COLUMN_CLASSNAMES.quantity, text())}><ActivityQuantity activity={activity} /></TableCell> : null;
    if ($[36] !== columns.rarity || $[37] !== item) {
      t6 = columns.rarity ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.rarity}>{item ? <ActivityRarity item={item} /> : EM_DASH}</TableCell> : null;
      $[36] = columns.rarity;
      $[37] = item;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    t7 = columns.from ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.from}><ActivityFrom activity={activity} className={text()} /></TableCell> : null;
    t8 = columns.to ? <TableCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.to}><ActivityTo activity={activity} className={text()} /></TableCell> : null;
    $[3] = activity;
    $[4] = columns.event;
    $[5] = columns.from;
    $[6] = columns.hideCollection;
    $[7] = columns.item;
    $[8] = columns.price;
    $[9] = columns.quantity;
    $[10] = columns.rarity;
    $[11] = columns.to;
    $[12] = context?.itemsLiveAddedAt;
    $[13] = context?.variant;
    $[14] = size;
    $[15] = T0;
    $[16] = T1;
    $[17] = t10;
    $[18] = t11;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    t10 = $[17];
    t11 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t12;
  if ($[39] !== activity || $[40] !== columns.time || $[41] !== context?.variant) {
    t12 = columns.time ? <TableCell className={classNames(ACTIVITY_TABLE_COLUMN_CLASSNAMES.time({
      variant: context?.variant
    }))}><ActivityFeedLiveTimestamp activity={activity} showArrow={true} /></TableCell> : null;
    $[39] = activity;
    $[40] = columns.time;
    $[41] = context?.variant;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== T0 || $[44] !== t12 || $[45] !== t2 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8) {
    t13 = <T0>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t12}</T0>;
    $[43] = T0;
    $[44] = t12;
    $[45] = t2;
    $[46] = t3;
    $[47] = t4;
    $[48] = t5;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  let t14;
  if ($[53] !== T1 || $[54] !== t10 || $[55] !== t11 || $[56] !== t13 || $[57] !== t9) {
    t14 = <T1 itemKey={t9} liveAddedAt={t10} variant={t11}>{t13}</T1>;
    $[53] = T1;
    $[54] = t10;
    $[55] = t11;
    $[56] = t13;
    $[57] = t9;
    $[58] = t14;
  } else {
    t14 = $[58];
  }
  return t14;
}
function _temp2(event_0) {
  event_0.stopPropagation();
}
function _temp(event) {
  event.stopPropagation();
}